export const EtatDemande = {
  created() {
    this.initETAT();
  },
  data() {
    return {
      messageMixin: "Message Mixin!",
      BROUILLON: { code: 1, libelle: "brouillon", icon: "texture" },
      VALIDATION_SUAIO: {
        code: 2,
        libelle: "en attente de validation par le SUAIO",
        icon: "mdi-verified_user"
      },
      TRAITEMENT_PEDAGOGIQUE: {
        code: 3,
        libelle: "en attente d'examen par l'enseignant",
        icon: "mdi-network_checked"
      },
      ACCEPTEE: {
        code: 4,
        libelle: "acceptée par l'enseignant",
        icon: "mdi-mood"
      },
      REFUSEE: {
        code: 5,
        libelle: "refusée par l'enseignant",
        icon: "mdi-not_interested"
      },
      NON_VALIDE: {
        code: 6,
        libelle: "demande non valide",
        icon: "mdi-iso"
      },
      RECTIFICATION: {
        code: 7,
        libelle: "en cours de rectification par l'étudiant",
        icon: "mdi-edit"
      },
      CONFIRMEE: {
        code: 8,
        libelle: "confirmée par l'étudiant",
        icon: "mdi-account-check"
      },
      DESISTEMENT: {
        code: 9,
        libelle: "désistement",
        icon: "mdi-account-arrow-right"
      },
      ABANDON: {
        code: 10,
        libelle: "abandonnée par l'étudiant",
        icon: "mdi-account-remove"
      },
      FINALISEE: {
        code: 11,
        libelle: "inscription finalisée par la scolarité",
        icon: "mdi-account-arrow-left"
      },
      ETAT: {}
    };
  },
  methods: {
    initETAT() {
      this.ETAT = {
        BROUILLON: this.BROUILLON,
        VALIDATION_SUAIO: this.VALIDATION_SUAIO,
        TRAITEMENT_PEDAGOGIQUE: this.TRAITEMENT_PEDAGOGIQUE,
        ACCEPTEE: this.ACCEPTEE,
        REFUSEE: this.REFUSEE,
        NON_VALIDE: this.NON_VALIDE,
        RECTIFICATION: this.RECTIFICATION,
        CONFIRMEE: this.CONFIRMEE,
        DESISTEMENT: this.DESISTEMENT,
        ABANDON: this.ABANDON,
        FINALISEE: this.FINALISEE
      };
    }
  }
};
